import script from "./FilterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterComponent.vue?vue&type=script&setup=true&lang=js"

import "./FilterComponent.vue?vue&type=style&index=0&id=5c455397&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c455397"]])

export default __exports__